module.exports = __webpack_public_path__ + "img/iphone-11-frame.98c39401.svg";